import angular from "angular";
import dcStudentUsageDetailController from "./student-usage-detail.controller";
import dcStudentUsageDetail from "./student-usage-detail.directive";
export default angular
  .module("directives.studentusagedetail", [])
  .controller("dcStudentUsageDetailController", dcStudentUsageDetailController)
  .directive("dsStudentUsageDetail", dcStudentUsageDetail);
